export const LOCALES = {
    FRENCH: 'fr-fr',
    ENGLISH: 'en-us',
    DEUTCH: 'de-de'
  }